import { render, staticRenderFns } from "./WaysOfLearningSidebar.vue?vue&type=template&id=3e0f3a55&scoped=true&"
import script from "./WaysOfLearningSidebar.vue?vue&type=script&lang=js&"
export * from "./WaysOfLearningSidebar.vue?vue&type=script&lang=js&"
import style0 from "./WaysOfLearningSidebar.vue?vue&type=style&index=0&id=3e0f3a55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0f3a55",
  null
  
)

export default component.exports